import { makeBetterEnum } from '../utils/betterEnum';

export const RouteEnum = makeBetterEnum(
  'VerifyFootprint',
  'ViewReductionPlans',
  'CleanPower',
  'SupplyChain',
  'CarbonRemoval',
  'CarbonAvoidance',
  'Benchmarks',
  'Reports',
  'Measurements'
);
export type RouteEnumType = keyof typeof RouteEnum;

export function isRouteType(value: string | null): value is RouteEnumType {
  if (value === null) {
    return false;
  }
  return value in RouteEnum;
}
